import { Storage } from './framework/storage';

export const store = new Storage('app');
